import React, { useState, useEffect } from 'react';
import { BaseURL } from "./Utils/baseURL";  
import MapComponent from './components/GISPortel/MapComponent';
import Dashboard from './components/GISPortel/Dashboard';
import UserAccount from './components/Auth/UserAccount';
import LoginPage from './components/Auth/LoginPage';
import { TreeDataProvider } from './components/GISPortel/TreeDataContext';
import 'leaflet/dist/leaflet.css';
import InputForm from './components/GISPortel/InputForm';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import EditTreeForm from './components/GISPortel/EditTreeForm';
import { ReactComponent as UserAccountIcon } from './images/UserAccountIcon.svg';
import logo from "./images/geoSurveyLogo.svg";
import { message } from 'antd';
import { ReactComponent as DashboardIcon } from './images/DashboardIcon.svg';
import './App.css';
import { Chart, registerables, CategoryScale, LinearScale } from 'chart.js';

Chart.register(...registerables, CategoryScale, LinearScale);

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [user, setUser] = useState({});
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
      fetchUserData(token);
    }
  }, []);
  
  useEffect(() => {
    if (isLoggedIn) {
      // navigate('/');
    }
  }, [isLoggedIn, navigate]);
  

  const fetchUserData = async (token) => {
    try {
      const response = await fetch(`${BaseURL}/auth/users/details/`, {
        method: "GET",
        headers: {
          "Authorization": `token ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        setUser(responseData.data);
      } else {
      }
    } catch (error) {
    
    }
  };

  const handleLogin = (userData, token) => {
    setIsLoggedIn(true);
    setUser(userData);
    sessionStorage.setItem('token', token);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUser(null);
    sessionStorage.removeItem('token');
    setIsAccountOpen(false);
    navigate('/');
  };

  const toggleAccount = () => {
    setIsAccountOpen((prev) => !prev);
  };

  return (
    <div className="app-container">
      <Routes>
        <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/inputform" element={<InputForm/>} />
        <Route path="/edit-tree/:tid" element={<EditTreeForm />} />
        <Route
          path="/"
          element={
            <div className="map-container">
              <MapComponent />

            </div>
          }
        />
      </Routes>
    </div>
  );
};

export default App;

